export const COLUMN_WIDTH = 200;
export const TITLE_COLUMN_WIDTH = 400;
export const ROW_ACTION_COLUMN_WIDTH = 60;
export const SUB_ACCORDION_INDENT = 4;
export const DATALABEL_PROPORTION_DISPLAY_THRESHOLD = 0.03;
export const MICRO_SCENARIO_LOCAL_STORAGE_FILTER_PREFIX = "micro-filter-units-";
